// store/modules/menu.js
export default {
  namespaced: true,
  state: {
    current: 0,
    // 原始菜单（含权限标识）
    rawList: [
      {
        name: "系统设置",
        icon: "SetUp",
        permission: "menu:system",
        menus: [
          { name: "工作台", path: "/dashboard/index", icon: "CoffeeCup", permission: "menu:quick" },
          { name: "站点管理", path: "/system/station/index", icon: "Location", permission: "menu:station" },
          { name: "企业管理", path: "/system/enterprise/index", icon: "OfficeBuilding", permission: "menu:enterprise" },
          { name: "订单管理", path: "/system/orders/index", icon: "CoffeeCup", permission: "menu:orders" },
          { name: "枪号管理", path: "/system/gun/index", icon: "Aim", permission: "menu:gun" },
          { name: "储备金记录", path: "/system/reserve/index", icon: "Money", permission: "menu:reserve" },
          { name: "卡号管理", path: "/system/card/index", icon: "CreditCard", permission: "menu:card" },
          { name: "提现管理", path: "/system/withdraw/index", icon: "Money", permission: "menu:withdraw" },
          // { name: "充值数据统计", path: "/statistics/recharge/index", icon: "Umbrella", permission: "menu:stat_recharge" },
          // { name: "加气数据统计", path: "/statistics/oil/index", icon: "Umbrella", permission: "menu:stat_oil" },
          { name: "用户管理", path: "/system/account/list", icon: "User", permission: "menu:account" },
          // { name: "管理员权限", path: "/system/account/auth", icon: "Umbrella", permission: "menu:account_auth" },
		  { name: "角色管理", path: "/system/role/index", icon: "User", permission: "menu:role" },		  
		  { name: "系统参数设置", path: "/system/index", icon: "Monitor", permission: "menu:system_config" },
        ]
      },
      {
        name: "运营管理",
        icon: "CoffeeCup",
        permission: "menu:operation",
        menus: [
          // 运营管理 group 里的所有 /feng/database/list 项
          { name: "平台资讯", path: "/feng/database/list", query: { dbname: "news" }, icon: "Bell", permission: "menu:news", eventKey: "fengdatabaselist" },
          { name: "微信用户", path: "/feng/database/list", query: { dbname: "user" }, icon: "User", permission: "menu:user", eventKey: "fengdatabaselist" },
          { name: "积分商品", path: "/feng/database/list", query: { dbname: "goods" }, icon: "Goods", permission: "menu:goods", eventKey: "fengdatabaselist" },
          { name: "首页轮播图", path: "/feng/database/list", query: { dbname: "lblist" }, icon: "Picture", permission: "menu:banner", eventKey: "fengdatabaselist" },
          { name: "商品订单", path: "/feng/database/list", query: { dbname: "goodsorder" }, icon: "List", permission: "menu:goodsorder", eventKey: "fengdatabaselist" },
          { name: "充值记录", path: "/feng/database/list", query: { dbname: "chargerecord" }, icon: "Wallet", permission: "menu:chargerecord", eventKey: "fengdatabaselist" },
          { name: "积分记录", path: "/feng/database/list", query: { dbname: "pointsrecord" }, icon: "Coin", permission: "menu:pointsrecord", eventKey: "fengdatabaselist" },
          { name: "加气记录", path: "/feng/database/list", query: { dbname: "oilrecord" }, icon: "Document", permission: "menu:oilrecord", eventKey: "fengdatabaselist" },
          { name: "充值优惠", path: "/feng/database/list", query: { dbname: "chargesys" }, icon: "Tickets", permission: "menu:chargesys", eventKey: "fengdatabaselist" },
          { name: "加气员", path: "/feng/database/list", query: { dbname: "yuser" }, icon: "UserFilled", permission: "menu:yuser", eventKey: "fengdatabaselist" },
          { name: "优惠券", path: "/feng/database/list", query: { dbname: "usercot" }, icon: "Coupon", permission: "menu:usercot", eventKey: "fengdatabaselist" },
        ]
      }
    ]
  },
  getters: {
      filteredList: (state, getters, rootState) => {
        const user = rootState.user?.user;
        const permissions = rootState.user?.permissions || [];
        // 超级管理员拥有所有菜单权限
        if (user && user.role === 'super_admin') {
          return state.rawList;
        }
        const menus = Array.isArray(state.rawList) ? state.rawList : [];
        function filterMenus(list) {
          if (!Array.isArray(list)) return [];
          const result = [];
          for (const item of list) {
            const hasSelfPermission = item.permission ? permissions.includes(item.permission) : false;
            let filteredChildren = [];
            if (item.menus && item.menus.length > 0) {
              filteredChildren = filterMenus(item.menus);
            }
            if (hasSelfPermission || filteredChildren.length > 0) {
              const newItem = { ...item };
              if (filteredChildren.length > 0) newItem.menus = filteredChildren;
              result.push(newItem);
            }
          }
          return result;
        }
        return filterMenus(menus);
      }
    },
    mutations: {
      setCurrent: (state, payload) => { state.current = payload; }
    },
    actions: {}
};